import * as yup from 'yup';

export const playerDetailsSchema = yup.object({
  playerRole: yup
    .string()
    .required('Player role is required')
    .test('not-empty', 'Please select player role', (v) => !!v && v !== ''),
  battingStyle: yup
    .string()
    .required('Batting style is required')
    .test('not-empty', 'Please select batting style', (v) => !!v && v !== ''),
  bowlingStyle: yup
    .string()
    .required('Bowling style is required')
    .test('not-empty', 'Please select bowling style', (v) => !!v && v !== ''),
});

export type PlayerDetailsFormValues = yup.InferType<typeof playerDetailsSchema>;
